module.exports = __webpack_public_path__ + "static/media/image.a3d1c609.png";